import { assertIsDefined } from '@gitbook/util-ts';

/**
 * Returns `true` if the DOM Selection is "backward", `false` otherwise
 */
export function isSelectionBackward(selection: Selection): boolean {
    const startNode = selection.anchorNode;
    const startOffset: number = selection.anchorOffset;
    const endNode = selection.focusNode;
    const endOffset: number = selection.focusOffset;

    assertIsDefined(startNode);
    assertIsDefined(endNode);

    const position: number = startNode.compareDocumentPosition(endNode);

    // 0 indicates same node. Selection is backward if the end offset is before the start offset.
    if (position === 0) {
        return endOffset < startOffset;
    }

    // Otherwise use the bitmask to check.
    return Boolean(position & Node.DOCUMENT_POSITION_PRECEDING);
}
